import {Alert, Grid, Skeleton} from "@mui/material"
import {useContext, useEffect, useState} from "react"
import CardDocumentation from "./CardDocumentation";
import {CompanyContext, CompanyContextValue} from "../../solicitation-new/context/companyContext";
import {HttpSolicitationRequestDocs} from "../../../http/solicitation/httpSolicitationRequestedDocs";
import {
    SolicitationRequestDocumentationView, SolicitationRequestDocumentationViewFields
} from "../../../types/solicitation/solicitationData";

interface SolicitationDocumentationProps {
    solicitationId: number
    dropSize?: 'small' | 'medium' | 'large',
    canDelete?: boolean
}

const SolicitationDocumentation = ({solicitationId, dropSize, canDelete}: SolicitationDocumentationProps) => {
    const { clientId } = useContext<CompanyContextValue>(CompanyContext);
    const [loading, setLoading] = useState<boolean>(false)
    const [docList, setDocList] = useState<SolicitationRequestDocumentationView[]>()
    
    const getList = () => {
        setLoading(true)
        HttpSolicitationRequestDocs.getList(solicitationId).then((r) => {
            const orderedDocs: SolicitationRequestDocumentationView[] = r.sort((a, b) => {
                return a[SolicitationRequestDocumentationViewFields.AchievedDocumentsQuantity] - b[SolicitationRequestDocumentationViewFields.AchievedDocumentsQuantity]
            })
            setDocList(orderedDocs)
            setLoading(false)
        })
    }

    useEffect(() => {
        getList()
    }, [])

    return (
        <Grid container spacing={4}>
            {
                loading ? Array.from({length: 3}).map((d, idx) => <Grid item xs={12} key={idx}><Skeleton height={90}/></Grid>)
                    :
                    docList && docList.length !== 0 ? docList.map((doc, idx) => 
                        <Grid item xs={12} key={idx}>
                            <CardDocumentation companyId={clientId} 
                                               solicitationId={solicitationId} 
                                               doc={doc}
                                               onReload={getList}
                                               size={dropSize}
                                               canDelete={canDelete}
                            />
                        </Grid>
                    )
                        :
                        <Grid item xs={12}>
                            <Alert severity={'info'}>Por el momento no han requerido documentos nuevos para esta solicitud</Alert>
                        </Grid>
            }
        </Grid>
    )
}

export default SolicitationDocumentation